/**
 * Menú V2 rollout (plan §5.1): every store sees the new page since the GA
 * release (2026-09-29); before it, staff and the pilot stores did. A
 * per-device override ('on' / 'off', set with `?menuV2=`) beats the rule.
 * Setting `MENU_V2_GA` back to false returns other stores to the classic
 * pages; the cleanup release (plan §6 M5) removes the flag.
 */
export const MENU_V2_GA = true;

/** ISO date until which the sidebar shows «Nuevo» on «Menú»; none at GA (owner decision). */
export const MENU_V2_NEW_UNTIL: string | null = null;

export const MENU_V2_PILOT_STORES: readonly string[] = ['bobas', 'bobasprueba'];

export type TMenuV2Override = 'default' | 'on' | 'off';

export const MENU_V2_OVERRIDES: readonly TMenuV2Override[] = [
  'default',
  'on',
  'off',
];

export function isMenuV2Override(value: unknown): value is TMenuV2Override {
  return (
    typeof value === 'string' &&
    (MENU_V2_OVERRIDES as readonly string[]).includes(value)
  );
}

export interface IMenuV2Input {
  override: TMenuV2Override;
  isStaff: boolean;
  stringId: string | null;
}

export function isMenuV2Enabled(input: IMenuV2Input): boolean {
  if (input.override === 'on') return true;
  if (input.override === 'off') return false;
  return (
    MENU_V2_GA ||
    input.isStaff ||
    (!!input.stringId &&
      MENU_V2_PILOT_STORES.includes(input.stringId.toLowerCase()))
  );
}

/** `MENU_V2_NEW_UNTIL` as a date; null when unset or invalid. */
export function menuV2NewUntil(value = MENU_V2_NEW_UNTIL): Date | null {
  if (!value) return null;
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
}
